import RuleActionModel from '@/common/models/rules/actions/rule-action-model';

export default class AddRiskScoreActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        ({score: this.score = 0} = fields);
    }

    getPayload() {
        return {
            ...super.getPayload(),
            score: Number(this.score),
        };
    }
}
